"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModal = void 0;
var react_1 = __importDefault(require("react"));
var react_modal_1 = __importDefault(require("react-modal"));
if (typeof window !== "undefined") {
    react_modal_1.default.setAppElement("body");
}
/**
 * Primitive modal component. Should only be used in special cases to create custom modals, and the Modal and FormModal components are not sufficient.
 * @param {boolean} isOpen - Required. Controls whether to hide or show the modal
 * @param {function} hideModal - Required. Function to be called when exiting the modal
 * @param {Object=} style - Custom style object used in react-modal
 * @param {Object=} style.content - Custom content styles
 * @param {Object=} style.overlay - Custom overlay styles
 * @param {boolean=} shouldCloseOnOverlayClick - Controls whether the overlay should close the modal
 * @param {boolean=} shouldCloseOnEsc - Controls whether the esc key should close the modal
 */
var BaseModal = function (_a) {
    var isOpen = _a.isOpen, hideModal = _a.hideModal, children = _a.children, _b = _a.style, style = _b === void 0 ? {} : _b, props = __rest(_a, ["isOpen", "hideModal", "children", "style"]);
    return (react_1.default.createElement(react_modal_1.default, __assign({ isOpen: isOpen, onRequestClose: function (e) {
            e.stopPropagation();
            hideModal();
        }, style: __assign(__assign({}, style), { content: __assign({ border: 0, borderRadius: 0, margin: 0, padding: 0 }, style.content), overlay: __assign({}, style.overlay) }) }, props), children));
};
exports.BaseModal = BaseModal;
